var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content-header pt-0 mb-2"},[_c('div',{staticClass:"row d-flex align-items-center"},[_c('div',{staticClass:"col-8"},[_c('h1',{staticClass:"m-0 text-dark"},[_vm._t("default")],2)]),_c('div',{staticClass:"col-4 d-flex justify-content-end align-items-center"},[_vm._t("right")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }